import React, { useState } from 'react';
import { PopupContainer } from 'components';
import { ScrollableContainer } from 'components';
import Frame from './Frame';
import { inject } from 'mobx-react';
import { EDITOR_SHOTS_STORE } from 'store';
import { ShotCutterProps } from './types';

const ShotCutter = (props: ShotCutterProps) => {
  const {
    shot,
    onClose,
    [EDITOR_SHOTS_STORE]: { splitShot }
  } = props;
  const frameNumbers: number[] = [];
  for (let i = shot.startFrame; i <= shot.endFrame; i++) {
    frameNumbers.push(i);
  }

  const initialFrameNumber = shot.endFrame + 1;
  const [newShotStartAt, setNewShotStartAt] = useState(initialFrameNumber);

  return (
    <PopupContainer
      onClose={onClose}
      title='Cut shot'
    >
      <ScrollableContainer>

        {frameNumbers.map(num =>
          <Frame
            key={num}
            frameNumber={num}
            onMouseEnter={() => setNewShotStartAt(num === shot.startFrame ? initialFrameNumber : num)}
            onMouseLeave={() => setNewShotStartAt(initialFrameNumber)}
            isFrameCut={newShotStartAt <= num}
            onFocus={newShotStartAt === num}
            onClick={() => splitShot(shot.id, num)}
          />
        )}

      </ScrollableContainer>
    </PopupContainer>
  );
};

export default inject(EDITOR_SHOTS_STORE)(ShotCutter);
